const videoPlayers = document.querySelectorAll(".video-player video");
videoPlayers.forEach((videoPlayer) => {
    videoPlayer.addEventListener("click", () => {
        if (!videoPlayer.playing) {
            videoPlayer.play();
        }
    });
    videoPlayer.addEventListener("play", () => {
        startPlayer(videoPlayer);
    });
    videoPlayer.addEventListener("pause", () => {
        stopPlayer(videoPlayer);
    });
});

function stopPlayer(video) {
    video.removeAttribute("controls");
    video.classList.remove("playing");
}

function startPlayer(video) {
    video.setAttribute("controls", true);
    video.classList.add("playing");
}

function handleIntersection(entries) {
    entries.forEach((entry) => {
        const videoPlayer = entry.target;
        if (!entry.isIntersecting && !videoPlayer.paused) {
            videoPlayer.pause();
        }
    });
}

const observer = new IntersectionObserver(handleIntersection, {
    threshold: [0.6],
});

videoPlayers.forEach((videoPlayer) => {
    observer.observe(videoPlayer);
});
